/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
/**
 * What is the origin of this grade history entry.
 */
export const GradeOrigin = /* #__PURE__ */ parsers.exactly('human', 'auto_test', 'rubric_migration', 'auto_test_2');
